import { Grid, useMediaQuery } from "@mui/material";
import { Labeled, ReferenceField, SelectField, Show, SimpleShowLayout, TextField } from "react-admin";
import { settings } from "app";
import { dormitoryRequests } from "api/dormitoryApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import { DormitoryAccommodationOrderStatusChoices } from "utils/choices";

const ShowAccommodationOrder = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за настанителна заповед"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          paddingY={0}
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid item xs={12} md={4}>
            <Labeled label="Номер">
              <TextField source="number" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={4}>
            <Labeled label="Настаняване">
              <ReferenceField
                source="accommodationId"
                reference={dormitoryRequests.getAccommodationsSelect()}
                link={false}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid item xs={12} md={4}>
            <Labeled label="Статус">
              <SelectField source="status" choices={DormitoryAccommodationOrderStatusChoices} />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowAccommodationOrder;
